var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.850708 16.0178C0.850708 7.65118 7.6416 0.868652 16.0083 0.868652C24.3749 0.868652 31.1658 7.65118 31.1658 16.0178C31.1658 24.3845 24.3749 31.167 16.0083 31.167C7.6416 31.167 0.850708 24.3845 0.850708 16.0178Z",
    fill: "#70768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67349 16.0178C2.67349 8.65918 8.64699 2.69144 16.0083 2.69144C23.3695 2.69144 29.343 8.65918 29.343 16.0178C29.343 23.3765 23.3695 29.3442 16.0083 29.3442C8.64699 29.3442 2.67349 23.3765 2.67349 16.0178Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3.64557
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39124 16.2039C4.39124 9.68893 9.67921 4.40747 16.1942 4.40747C22.7092 4.40747 27.9972 9.68893 27.9972 16.2039C27.9972 22.7189 22.7092 28.0004 16.1942 28.0004C9.67921 28.0004 4.39124 22.7189 4.39124 16.2039Z",
    fill: "#70768C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMedal);
export default __webpack_public_path__ + "static/media/inactive-medal.0f1be7c74d46345a7442bbcc50bf7fe5.svg";
export { ForwardRef as ReactComponent };